import React from 'react';

import TireComparisonChartBar from '../tire-comparison-chart-bar/tire-comparison-chart-bar';
import { getLabels } from './tire-comparison-line-util';

import './tire-comparison-line.scss';

interface TireComparisonLineProps {
  className?: string;
  comparisonDistance?: number;
  distance: number;
  hideRecommended?: boolean;
  isDry?: boolean;
  isWet?: boolean;
  max: number;
  min: number;
  styleName?: string;
}

function TireComparisonLine(props: TireComparisonLineProps) {
  const {
    className,
    comparisonDistance = 0,
    distance = 0,
    hideRecommended = false,
    isDry = false,
    isWet = false,
    max = 0,
    min = 0
  } = props;

  const { comparisonDistanceLabel, distanceLabel } = getLabels({
    comparisonDistance,
    distance,
    min
  });

  return (
    <div
      className={className}
      styleName={
        hideRecommended ? 'container-without-recommendation' : 'container'
      }
    >
      <TireComparisonChartBar
        label={distanceLabel}
        showCar={isDry || isWet}
        styleName={`bar-${isWet ? 'wet' : ''}${isDry ? 'dry' : ''}${
          !isDry && !isWet ? 'recommended' : ''
        }`}
        width={((distance - min) / (max - min)) * 100}
        zIndex={2}
      />
      {comparisonDistance > distance && (
        <TireComparisonChartBar
          label={comparisonDistanceLabel}
          styleName={`bar-${isWet ? 'wet-comparison' : ''}${
            !isWet ? 'recommended-comparison' : ''
          }`}
          width={((comparisonDistance - min) / (max - min)) * 100}
          zIndex={1}
        />
      )}
      <TireComparisonChartBar styleName="bar-default" width={100} zIndex={0} />
    </div>
  );
}

export default TireComparisonLine;
